import { create } from 'zustand';
import type { AppState } from '../types';
import { api } from '../services/api';

// Load user from localStorage on initialization
const loadPersistedUser = () => {
  try {
    const storedUser = localStorage.getItem('vdi_user');
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    return null;
  }
};

export const useStore = create<AppState>((set) => ({
  user: loadPersistedUser(),
  token: null,
  session: null,

  setUser: (user) => {
    // Persist user to localStorage
    if (user) {
      localStorage.setItem('vdi_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('vdi_user');
    }
    set({ user });
  },

  setToken: (token) => set({ token }),

  setSession: (session) => set({ session }),

  logout: () => {
    api.clearToken();
    localStorage.removeItem('vdi_user');
    set({ user: null, token: null, session: null });
  },
}));
